<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { todoComputed, todoMethods} from "@/state/helpers";
import { Helper } from "@/mixin/helper";
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Planner Menu',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },

  computed: {
    ...todoComputed,
    title() {
      return this.$t('planner.title')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ title }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col v-if="hasAccess(['sms-planner-wo-board:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Planner WO Board' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_checkmark-circle"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('planner.column.woBoard') }}</h4>
                    <p>{{ $t('planner.subColumn.woBoard') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="hasAccess(['sms-planner-calendar-schedule:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Planner Calendar Schedule' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_clock"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('planner.column.calendarSchedule') }}</h4>
                    <p>{{ $t('planner.subColumn.calendarSchedule') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="hasAccess(['sms-planner-technicians:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Planner Technicians' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('planner.column.technicians') }}</h4>
                    <p>{{ $t('planner.subColumn.technicians') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col v-if="hasAccess(['sms-planner-package:read'])" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Planner Package' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-fill_cube"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('planner.column.package') }}</h4>
                    <p>{{ $t('planner.subColumn.package') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
